// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xw_a bhv_uj bhv_ua bhv_vx bhv_qk bhv_sl bhv_qb"};